export enum MainActions {
    JumpToQuestion = 'Jump To Question',
    Notify = 'Notify',
    NotifyWait = 'Notify & Wait',
    // JumpToCamera = 'Jump To Camera',
    // JumpToGPS = 'Jump To GPS',
    // JumpToSignature = 'Jump To Signature'
};

export enum MathOps {
    LessThan = 'less-than',
    GreaterThan = 'greater-than',
    EqualTo = 'equal-to'
}

export enum LogicalOps  {
    AND = 'and',
    NOT = 'not', 
    OR  = 'or'
};

export enum GeofenceOps  {
    IN = 'in',
    OUT = 'out'
};